import { useTranslation } from 'react-i18next';

import { useDensity } from '../lib/density';
import { Segmented } from './Segmented';

/**
 * Die Umschaltung der Zeilenhoehe, wie sie ueber jeder langen Liste steht.
 *
 * Sie sitzt in derselben Leiste wie die Spaltenwahl: Beides ist eine
 * Einstellung der Ansicht und keine Einschraenkung der Daten -- und beides
 * gehoert damit nicht zwischen die Filter.
 */
export function DensityToggle() {
  const { t } = useTranslation();
  const [density, setDensity] = useDensity();

  return (
    <Segmented
      ariaLabel={t('density.label')}
      value={density}
      onChange={setDensity}
      options={[
        { value: 'comfortable', label: t('density.comfortable') },
        { value: 'compact', label: t('density.compact') },
      ]}
    />
  );
}
